import React from "react";
import { XCircle, CheckCircle, AlertCircle } from "lucide-react";

const ConfirmModal = ({
  isOpen,
  type = "confirm", // confirm | success | error | warning
  title = "Confirmar acción",
  message = "¿Estás seguro?",
  onConfirm,
  onCancel,
  confirmText = "Aceptar",
  cancelText = "Cancelar",
}) => {
  if (!isOpen) return null;

  const getStyles = () => {
    switch (type) {
      case "success":
        return {
          icon: <CheckCircle className="w-10 h-10 text-green-500" />,
          header: "bg-green-100 text-green-700",
          button: "bg-green-600 hover:bg-green-700",
        };
      case "error":
        return {
          icon: <XCircle className="w-10 h-10 text-red-500" />,
          header: "bg-red-100 text-red-700",
          button: "bg-red-600 hover:bg-red-700",
        };
      case "warning":
        return {
          icon: <AlertCircle className="w-10 h-10 text-yellow-500" />,
          header: "bg-yellow-100 text-yellow-700",
          button: "bg-yellow-600 hover:bg-yellow-700",
        };
      case "confirm":
      default:
        return {
          icon: <AlertCircle className="w-10 h-10 text-blue-500" />,
          header: "bg-blue-100 text-blue-700",
          button: "bg-blue-600 hover:bg-blue-700",
        };
    }
  };

  const styles = getStyles();

  const showTwoButtons = type === "warning" || type === "confirm";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-6 animate-fadeIn">
        {/* Encabezado */}
        <div className={`flex items-center gap-3 mb-4 p-2 rounded-lg ${styles.header}`}>
          {styles.icon}
          <h2 className="text-lg font-bold">{title}</h2>
        </div>

        {/* Mensaje */}
        <p className="text-gray-600 mb-6">{message}</p>

        {/* Botones */}
        <div className="flex justify-end gap-3">
          {showTwoButtons && (
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-600"
            >
              {cancelText}
            </button>
          )}

          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg text-white font-semibold ${styles.button}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
